import {
  GlobalContext,
  type IGlobalContext,
} from "@via/context/global-context.tsx";
import { useContext } from "react";
export const useGlobal = (): IGlobalContext => {
  const context = useContext(GlobalContext);
  if (!context) {
    throw new Error("useGlobalContext must be used within a GlobalProvider");
  }
  return context;
};
